<template>
<div>
	<div class="infomationTable">
		<table class="table">
		    <tr>
			    <th>序号</th>
			    <th>培训开始时间</th>
			    <th>培训结束时间</th>
			    <th>培训地点</th>
			    <th>培训企业组织名称</th>
			    <th>培训内容</th>
			    <th>获得何种证书</th>
			    <th>操作</th>
		    </tr>
		    <tr v-for="(item,index) in formList">
		        <td>
		        	<div class="label">序号</div>
		        	{{index+1}}
		        </td>
		        <td>
		        	<div class="label">培训开始时间</div>
		        	{{item.startTime}}
		        </td>
		        <td>
		        	<div class="label">培训结束时间</div>
		        	{{item.endTime}}
		        </td>
		        <td>
		        	<div class="label">培训地点</div>
		        	{{item.adress}}
		        </td>
		        <td>
		        	<div class="label">培训企业组织名称</div>
		        	{{item.groupName}}
		        </td>
		        <td>
		        	<div class="label">培训内容</div>
		        	{{item.content}}
		        </td>
		        <td>
		        	<div class="label">获得何种证书</div>
		        	{{item.certificate}}
		        </td>
		      	<td>
		      		<div class="label">操作</div>
		      		<div class="edit" @click="edit(item.id)">编辑</div>
		      	</td>
		    </tr>
		</table>
	</div>
	
	<!-- 添加按钮 -->
	<div class="addBtn" @click="add"></div>
	
	<!-- 编辑、新增的弹窗 -->
	<div class="infomationAddEdit" v-if="popShow">
		<div class="mask"></div>
		<div class="form">
			<div class="close" @click="cancel"></div>
			<div class="tit f-16 fb">
				<template v-if="addOrEdit==1">
					新增
				</template>
				<template v-if="addOrEdit==2">
					编辑
				</template>	
			</div>
	        <div class="item cf">
	        	<div class="name fl"><span>*</span>培训开始时间</div>
	        	<div class="ovh text">
	        		<el-date-picker
			            v-model="popData.startTime"
			            value-format="yyyy-MM-dd"
			            placeholder="请选择培训开始时间"
			            :picker-options="startPickerOptions">
			        </el-date-picker>
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>培训结束时间</div>
	        	<div class="ovh text">
	        		<el-date-picker
			            v-model="popData.endTime"
			            value-format="yyyy-MM-dd"
			            placeholder="请选择培训结束时间"
			            :picker-options="endPickerOptions">
			        </el-date-picker>
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>培训地点</div>
	        	<div class="ovh text">
					<input type="text" v-model="popData.adress" name="adress" placeholder="请填写培训地点">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>培训企业组织名称</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.groupName" name="groupName" placeholder="请填写培训企业组织名称">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>毕业培训内容</div>
	        	<div class="ovh text">
					<input type="text" v-model="popData.content" name="content" placeholder="请填写培训内容">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>获得何种证书</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.certificate" name="certificate" placeholder="请填写获得何种证书">
				</div>
			</div>

	      	<div class="btnBox">
				<div class="btn btn1" @click="save">保存</div>
				<div class="btn btn2" @click="cancel">取消</div>
	      	</div>
		</div>
	</div>
</div>
</template>
<script>
import { 
  experienceList,
  experienceAdd,
  experienceEdit,
  experienceDelete,
  experienceQueryById
} from "@/api/tableapi";

export default {
	name: 'tableexperience',
	props:{
		isshow: {
	      	type: Boolean,
  			default: {}
	    }
	},
	watch: {
	    isshow: {
	      immediate: true,
	      handler(newval,oldval) {
	        if (newval) {
	        	this.initData()
	        }
	      }
	    },
	},
	data(){
		return{
		    formList:[],
		    addOrEdit:1,   //1是新增2是编辑
		    popData:{
		    	startTime:'',
		    	endTime:'',
		    	adress:'',
		    	groupName:'',
		    	content:'',
		    	certificate:''
		    },
		    popShow:false,

		    xueliOptions:[]
		}
	},
	computed: {
	    startPickerOptions() {
	      return {
	        disabledDate: time => {
	          return this.popData.endTime ? time.getTime() > new Date(this.popData.endTime).getTime() : false;
	        }
	      };
	    },
	    endPickerOptions() {
	      return {
	        disabledDate: time => {
	          return this.popData.startTime ? time.getTime() < new Date(this.popData.startTime).getTime() : false;
	        }
	      };
	    }
	},
	created(){
		this.initData()
	},
  	methods:{
  		//获取当前表格的数据
  		initData(){
  			let that=this
  			experienceList("").then(res=>{
              if (res.success) {               
                that.formList=res.result.records
              }
            })
        },

        //添加
	    add(){
	    	let that=this
	    	that.addOrEdit=1
	    	that.popData={
		    	startTime:'',
		    	endTime:'',
		    	adress:'',
		    	groupName:'',
		    	content:'',
		    	certificate:''
		    }

		    that.popShow=true
	    },

	    //编辑
	    edit(id){
	    	let that=this
	    	experienceQueryById(id).then(res=>{
		        //console.log(res)
		        if(res.success){
		          that.addOrEdit=2

		          if(res.result.startTime!=''&&res.result.startTime!=null){
		            let startTime=res.result.startTime
		            res.result.startTime=startTime.split(" ")[0]
		          }

		          if(res.result.endTime!=''&&res.result.endTime!=null){
		            let endTime=res.result.endTime
		            res.result.endTime=endTime.split(" ")[0]
		          }

		          that.popData=res.result
		          that.popShow=true
		        }else{
		          that.$message.error(res.message)
		          return false
		        }
		    })
	    },

	    save(){
	    	let that=this

		    //验证，表格结构数据中有必填和校验正则
		    if (that.popData.startTime==''||that.popData.startTime==null) {
		    	that.$message.error('请选择培训开始时间！');
		    	return false
		    }

		    if (that.popData.endTime==''||that.popData.endTime==null) {
		    	that.$message.error('请选择培训结束时间！');
		    	return false
		    }

		    if (that.popData.adress==''||that.popData.adress==null) {
		    	that.$message.error('请填写培训地点！');
		    	return false
		    }

		    if (that.popData.groupName==''||that.popData.groupName==null) {
		    	that.$message.error('请填写培训企业组织名称！');
		    	return false
		    }

		    if (that.popData.content==''||that.popData.content==null) {
		    	that.$message.error('请填写培训内容！');
		    	return false
		    }

		    if (that.popData.certificate==''||that.popData.certificate==null) {
		    	that.$message.error('请填写获得何种证书！');
		    	return false
		    }

		    //通过验证
		    that.popData.startTime += " 00:00:00"
		    that.popData.endTime += " 00:00:00"
		    //添加
		    if (that.addOrEdit==1) {
		    	experienceAdd(that.popData).then(res=>{
	              if (res.success) {
	              	that.initData()            
	                that.$message.success('添加成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
		    //编辑
		    if (that.addOrEdit==2) {
		    	experienceEdit(that.popData).then(res=>{
	              if (res.success) { 
	              	that.initData()              
	                that.$message.success('编辑成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
	    },

	    cancel(){
	    	let that=this
	    	that.popShow=false
	    }
  	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/tableexperience/index.vue